module.exports = __webpack_public_path__ + "static/img/15.f105caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/15.jpg
// module id = l2RJ
// module chunks = 1